import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useCallback, useState } from 'react';

import {
  FinishAppointmentDocument,
  GetUncompletedAppointmentsNotificationsCountDocument,
} from '~/graphql/generated/graphql';
import { profileDrawerState } from '~/state/partials/patient_profile_drawer/atoms';

export const useFinishAppointment = (appointmentId: string) => {
  const [isFinishing, setIsFinishing] = useState(false);
  const setProfileDrawerState = useSetAtom(profileDrawerState);

  // 会計済(配送待ち) -> 完了
  const [finishAppointment] = useMutation(FinishAppointmentDocument, {
    refetchQueries: [{ query: GetUncompletedAppointmentsNotificationsCountDocument }],
  });
  const handleFinish = useCallback(async () => {
    try {
      setIsFinishing(true);

      await finishAppointment({
        variables: {
          input: {
            appointmentId,
          },
        },
      });
      setProfileDrawerState((_state) => ({
        ..._state,
        error: null,
      }));
    } catch (_error) {
      setProfileDrawerState((_state) => ({
        ..._state,
        error: _error?.message || 'エラーが発生しました',
      }));
    } finally {
      setIsFinishing(false);
    }
  }, [appointmentId, finishAppointment, setProfileDrawerState]);

  return { finishing: isFinishing, handleFinish };
};
